import { React, useState, useEffect } from 'react';
import { Nav, Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { Paths } from 'paths';
import "styles/theme.css";
import getBackend from 'backend/backend';
import { useLocation } from 'react-router-dom';


const SidebarNavLink = ({ title, path }) => {
    const location = useLocation();
    return (
        <Nav.Link as={NavLink} to={path} className={`header-text sidebar-link ${location.pathname === path ? 'text-decoration-underline' : ''}`}>{title}</Nav.Link>
    );
};


const SidebarGroup = ({ title, children }) => {
    const [show, setShow] = useState(true);
    const location = useLocation();

    useEffect(() => {
        for (const child of children) {
            if (child.props && child.props.path && child.props.path === location.pathname) {
                setShow(true);
            }
        }
        return () => {
        }
    }, [location.pathname, children, show, title]);

    const handleTitleClick = (e) => {
        //TODOsetShow(!show);
    };

    return (
        <div className="sidebar-group">
            <Nav.Link 
                className="header-text sidebar-link fw-bold"
                onClick={handleTitleClick}
            >
                {title}
            </Nav.Link>
            {show &&
                <div className="ms-3">
                    {children}
                </div>
            }
        </div>
    );
};

export const Sidebar = (props) => {

    useEffect(() => {
        let canceled = false;

        const getProfile = async () => {
            const result = await getBackend().profile();
            if (canceled)
                return;

            if (result.error !== null) {
                window.location.href = Paths.NotFound.path;
            }
        };

        getProfile();

        return async () => {
            canceled = true;
        }
    }, []);

    return (
            <Row>
                <Col xs={12} sm={6} md={4} lg={3} xl={2} xxl={2} className="border-end custom-sidebar">
                    <Nav className="flex-column">
                        <SidebarGroup title="LLM">
                            <SidebarNavLink title="Add Worker" path={Paths.AddWorker.path} />
                            <SidebarNavLink title="Workers" path={Paths.Workers.path} />
                            <SidebarNavLink title="API Keys" path={Paths.ApiKeys.path} />
                            <SidebarNavLink title="Chat" path={Paths.Chat.path} />
                        </SidebarGroup>
                        <SidebarGroup title="RAG">
                            <SidebarNavLink title="Create Data Index" path={Paths.CreateDataIndex.path} />
                            <SidebarNavLink title="Data Indexes" path={Paths.DataIndexes.path} />
                            <SidebarNavLink title="Chat with Data" path={Paths.ChatDataIndex.path} />
                        </SidebarGroup>
                        <SidebarGroup title="Account">
                            <SidebarNavLink title="Account" path={Paths.Account.path} />
                            {false &&
                                <SidebarNavLink title="Notifications" path={Paths.Notifications.path} />
                            }
                            {false &&
                                <SidebarNavLink title="Billing" path={Paths.Billing.path} />
                            }
                            {false &&
                                <SidebarNavLink title="Settings" path={Paths.Settings.path} />
                            }
                        </SidebarGroup>
                    </Nav>
                </Col>
                <Col xs={12} sm={6} md={8} lg={9} xl={10} xxl={10} className="min-vh-100">
                    {props.children}
                </Col>
            </Row>
    );
};

export default Sidebar;
